import type { UsageLive } from "../api/types";

/** The headline number: how many people are on the tree right now, against
 *  the allowance they are measured by. Over-allowance is the Worker's call
 *  (`live.over`) — `included` only labels the number. */
export function LiveSeats({
  live,
  included,
}: {
  live: UsageLive;
  included: number | null;
}): JSX.Element {
  const colour = live.over ? "#b45309" : "#166534";
  return (
    <section style={{ marginBottom: 20 }}>
      <p
        role="status"
        style={{ margin: 0, fontSize: 40, fontWeight: 700, color: colour, lineHeight: 1.1 }}
      >
        {live.people} on now
        <span style={{ fontSize: 16, fontWeight: 400, color: "#444", marginLeft: 12 }}>
          {included === null ? "no allowance set" : `of ${included} included`}
        </span>
      </p>
      <p style={{ margin: "4px 0 0", color: "#666" }}>
        {live.devices} {live.devices === 1 ? "device" : "devices"}
      </p>
    </section>
  );
}
